(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // this.setHeaderHeight();

      // window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // setHeaderHeight() {
    //   document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    // }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-feedback"] && !window.DesignMode) return;
  try {
    
  class PageFeedback extends HTMLElement {
    constructor() {
      super();
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.handleSmileyChange = this.handleSmileyChange.bind(this);
    }
    connectedCallback() {
      this.data = {
        successMessage: this.getAttribute('data-success-message'),
        errorMessage: this.getAttribute('data-error-message'),
        botMessage: this.getAttribute('data-bot-message')
      }
      this.form = this.querySelector('form.page-feedback__form');
      this.honeyPot = this.querySelector('#message_1');
      this.submittedMessage = this.querySelector('.page-feedback__form__submitted p');
      this.submitButton = this.querySelector('.page-feedback__form__submit');
      this.resetButton = this.querySelector('.page-feedback__form__reset');
      this.smileyInputs = this.querySelectorAll('.page-feedback__form__smileys input');

      this.formState = PageFeedback.FORM_STATES.DEFAULT;

      this.form.addEventListener('submit', this.handleFormSubmit);
      this.form.submit = (event) => {
        this.setFormState(PageFeedback.FORM_STATES.ERROR, this.data.botMessage);
        this.honeyPot.value = '';
        event.preventDefault();
      }

      this.resetButton.addEventListener('click', () => {
        this.setFormState(PageFeedback.FORM_STATES.DEFAULT);
      });

      this.smileyInputs.forEach((input) => {
        input.addEventListener('change', this.handleSmileyChange);
      });
      this.handleSmileyChange();
      this.setFormDeviceType();
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.handleFormSubmit);
      this.smileyInputs.forEach((input) => {
        input.removeEventListener('change', this.handleSmileyChange);
      });
    }

    static get FORM_STATES() {
      return {
        DEFAULT: 0,
        LOADING: 1,
        SUBMITTED: 2,
        ERROR: 3
      }
    }

    get isHoneyPotFilled() {
      return this.honeyPot.value;
    }

    get isSmileySelected() {
      return Array.from(this.smileyInputs).some(input => input.checked);
    }

    setFormDeviceType() {
      const deviceType = window.innerWidth < 750 ? 'mobile' : 'desktop';
      this.form.querySelector('input[name="device_type"]').value = deviceType;
    }

    /**
     * Handles the form submission asynchronously.
     *
     * @param {Event} event - The event object representing the form submission.
     * @returns {Promise} - A promise that resolves when the form submission is handled.
     */
    async handleFormSubmit(event) {
      event.preventDefault();

      // Catch bots and don't submit the form
      if (this.isHoneyPotFilled || !this.isSmileySelected) {
        this.setFormState(PageFeedback.FORM_STATES.ERROR, this.data.botMessage);
        this.honeyPot.value = '';
        return;
      }

      this.setFormState(PageFeedback.FORM_STATES.LOADING);

      const formData = new FormData(this.form);
      const data = Object.fromEntries(formData.entries());

      try {
        const res = await fetch(this.form.action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: JSON.stringify(data)
        })
        if (!res.ok) {
          throw new Error('Failed to submit form');
        }
        this.setFormState(PageFeedback.FORM_STATES.SUBMITTED);
      } catch (error) {
        this.setFormState(PageFeedback.FORM_STATES.ERROR, error.message || this.data.errorMessage);
      }
    }

    handleSmileyChange() {
      const isSmileySelected = Array.from(this.smileyInputs).some(input => input.checked);
      this.submitButton.disabled = !isSmileySelected;
    }

    /**
     * Sets the state of the form.
     *
     * @param {number} state - The new state of the form.
     */
    setFormState(state, message = '') {
      this.formState = state;
      const stateClasses = [
        'page-feedback--empty',
        'page-feedback--loading',
        'page-feedback--submitted',
        'page-feedback--error'
      ]; // 0 = default, 1 = loading, 2 = submitted, 3 = error
      this.classList.remove(...stateClasses);
      this.classList.add(stateClasses[state]);
      this.submittedMessage.textContent = state === PageFeedback.FORM_STATES.SUBMITTED
        ? (message || this.data.successMessage)
        : (message || this.data.errorMessage);
    }
  }

  customElements.define('page-feedback', PageFeedback)

  } catch(e) { console.error(e); }
})();
})();
